"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Form = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _clsx = _interopRequireDefault(require("clsx"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var Form = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var PREFIX = (0, _getPrefixCls.getPrefixCls)('form');
  var _useState = (0, _react.useState)({}),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    fieldsValue = _useState2[0],
    setInnerFieldsValue = _useState2[1];
  var fieldsRef = (0, _react.useRef)(fieldsValue);
  var setFieldValue = function setFieldValue(fieldName, fieldValue) {
    setFieldsValue((0, _defineProperty2.default)({}, fieldName, fieldValue));
  };
  var setFieldsValue = function setFieldsValue(fields) {
    var _props$onValuesChange;
    fieldsRef.current = _objectSpread(_objectSpread({}, fieldsRef.current), fields);
    setInnerFieldsValue(fieldsRef.current); // setTimeout(() => {

    (_props$onValuesChange = props.onValuesChange) === null || _props$onValuesChange === void 0 ? void 0 : _props$onValuesChange.call(props, fields, fieldsRef.current); // });
  };

  var getFieldValue = function getFieldValue(fieldName) {
    return fieldsValue[fieldName];
  };
  var getFieldsValue = function getFieldsValue() {
    return fieldsValue;
  };
  var resetFields = function resetFields() {
    setInnerFieldsValue({});
  }; // 把子组件的值给父组件用

  _react.default.useImperativeHandle(ref, function () {
    return {
      getFieldValue: getFieldValue,
      setFieldValue: setFieldValue,
      setFieldsValue: setFieldsValue,
      getFieldsValue: getFieldsValue,
      resetFields: resetFields
    };
  });
  (0, _react.useEffect)(function () {
    setFieldsValue(props.initialValues || {});
  }, [props.initialValues]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(PREFIX, props.className)
  }, _react.default.Children.map(props.children, function (child) {
    var isValidElement = /*#__PURE__*/_react.default.isValidElement(child);
    var element = isValidElement ? child : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, child);
    var fieldName = (isValidElement ? child.props.name : '') || '';
    var childProps = isValidElement ? child.props : {};
    return /*#__PURE__*/_react.default.cloneElement(element, _objectSpread({
      readOnly: props.readOnly,
      value: fieldsValue[fieldName],
      onChange: function onChange(newValue) {
        return setFieldValue(fieldName, newValue);
      }
    }, childProps));
  }));
});
exports.Form = Form;